<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="cubes"/>
          {{ $t('plan') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.countryIndex" @input="load">
          <b-tab v-for="item in $store.state.countries" :key="item._id" :title="item.name"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['admin', 'owner', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('name') }}</div>
            <div class="col-lg-4">{{ $t('detail') }}</div>
            <div class="col-lg-4">{{ $t('setup') }}</div>
            <div class="col-lg-1"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <div v-if="['owner', 'tech'].includes($store.state.user.role)">
                <b class="">Mã: </b>
                <span>{{ item._id }}</span>
              </div>
              <div>
                <b class="">{{ $t('name') }}: </b>
                <span>{{ item.name }}</span>
              </div>
              <div>
                <span v-if="item.country"><label class="badge badge-info mr-1">{{ item.country.name }}</label></span>
                <span v-if="item.default"><label class="badge badge-secondary mr-1">{{ $t('default') }}</label></span>
                <span v-if="item.advanced"><label class="badge badge-warning mr-1">{{ $t('advanced') }}</label></span>
                <span v-if="item.unlimitedUser">
                  <label class="badge badge-primary mr-1">
                    {{ $t('unlimitedUser') }}
                  </label>
                </span>
              </div>
              <template v-if="item.unlimitedUser">
                <div>
                  <b>{{ $t('audioCallPrice') }}: </b>
                  <span>
                    {{ item.audioCallPrice ? item.audioCallPrice : 0 | numFormat }}
                    {{ item.country.currency }}
                  </span>
                </div>
                <div>
                  <b>{{ $t('videoCallPrice') }}: </b>
                  <span>{{ item.videoCallPrice ? item.videoCallPrice : 0 | numFormat }} {{
                      item.country.currency
                    }}</span>
                </div>
                <div>
                  <b>{{ $t('customerPrice') }}: </b>
                  <span>{{ item.customerPrice ? item.customerPrice : 0 | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <b>{{ $t('opportunityPrice') }}: </b>
                  <span>{{ item.opportunityPrice ? item.opportunityPrice : 0 | numFormat }} {{
                      item.country.currency
                    }}</span>
                </div>
                <div>
                  <b>{{ $t('ticketPrice') }}: </b>
                  <span>{{ item.ticketPrice ? item.ticketPrice : 0 | numFormat }} {{ item.country.currency }}</span>
                </div>
                <div>
                  <b>{{ $t('campaignContactPrice') }}: </b>
                  <span>{{
                      item.campaignContactPrice ? item.campaignContactPrice : 0 | numFormat
                    }} {{ item.country.currency }}</span>
                </div>
              </template>
              <!--              <div><b>{{ $t('storageLimit') }}: </b><span>{{ item.storageLimit | numFormat}}</span></div>-->
            </div>
            <div class="col-lg-4">
              <div v-if="!item.unlimitedUser">
                <span>{{ $t('userPrice') }}: </span>
                <span>{{ item.userPrice | numFormat }} {{ item.country.currency }}</span>
              </div>
              <div v-if="!item.unlimitedUser">
                <span>{{ $t('channelPrice') }}: </span>
                <span>{{ item.channelPrice | numFormat }} {{ item.country.currency }}</span>
              </div>
              <div v-if="!item.unlimitedUser && item.callEnabled && item.videoEnabled">
                <span>{{ $t('videoCCUPrice') }}: </span>
                <span>{{ item.videoCCUPrice | numFormat }} {{ item.country.currency }}</span>
              </div>
              <div v-if="!item.unlimitedUser && item.callEnabled && item.videoEnabled">
                <span>{{ $t('videoRecordingPrice') }}: </span>
                <span>{{ item.videoCCURecordingPrice | numFormat }} {{ item.country.currency }}</span>
              </div>
              <div v-if="!item.unlimitedUser && item.callEnabled && item.videoEnabled">
                <span>{{ $t('videoCCUNumber') }}: </span>
                <span>{{ item.videoCCUNumber | numFormat }}</span>
              </div>
              <div>
                <span>{{$t('advancedNumber')}}: </span>
                <span v-if="item.advancedNumber != -1" >{{ item.advancedNumber | numFormat }}</span>
                <span v-else class="badge badge-success">Không giới hạn</span>
              </div>
              <div>
                <span>{{$t('channelNumber')}}: </span>
                <span v-if="item.channelNumber != -1">{{ item.channelNumber | numFormat }}</span>
                <span v-else class="badge badge-success">Không giới hạn</span>
              </div>
              <div>
                <span>{{$t('numberLimit')}}: </span>
                <span v-if="item.numberLimit != -1">{{ item.numberLimit | numFormat }}</span>
                <span v-else class="badge badge-success">Không giới hạn</span>
              </div>
              <div>
                <span>{{$t('socialNetworkAccountLimit')}}: </span>
                <span v-if="item.socialNetworkAccountLimit != -1">{{ item.socialNetworkAccountLimit | numFormat }}</span>
                <span v-else class="badge badge-success">Không giới hạn</span>
              </div>
              <div>
                <span>{{$t('automationWorkflowLimit')}}: </span>
                <span v-if="item.automationWorkflowLimit" >{{ item.automationWorkflowLimit | numFormat }}</span>
                <span v-else class="badge badge-success">Không giới hạn</span>
              </div>
              <div>
                <span>{{$t('automationLimit')}}: </span>
                <span v-if="item.automationLimit" >{{ item.automationLimit | numFormat }}</span>
                <span v-else class="badge badge-success">Không giới hạn</span>
              </div>
            </div>
            <div class="col-lg-4">
              <div>
                <span>{{ $t('callEnabled') }}: </span>
                <label v-if="item.callEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.callEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div>
                <span>{{ $t('multiChannelEnabled') }}: </span>
                <label v-if="item.multiChannelEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.multiChannelEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="item.callEnabled" >
                <span>{{ $t('videoEnabled') }}: </span>
                <label v-if="item.videoEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-else class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div>
                <span>{{ $t('kpiEnabled') }}: </span>
                <label v-if="item.kpiEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.kpiEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div>
                <span>{{ $t('phonebookEnabled') }}: </span>
                <label v-if="item.phonebookEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.phonebookEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('ticketEnabled') }}: </span>
                <label v-if="item.ticketEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.ticketEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('integrationEnabled') }}: </span>
                <label v-if="item.integrationEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.integrationEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('aiEnabled') }}: </span>
                <label v-if="item.aiEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.aiEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('aiMaxConcurrent') }}: </span>
                <label class="badge badge-secondary">{{ item.aiMaxConcurrent || 5 }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('callCampaignEnabled') }}: </span>
                <label v-if="item.callCampaignEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.callCampaignEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('pipelineEnabled') }}: </span>
                <label v-if="item.pipelineEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.pipelineEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('orderEnabled') }}: </span>
                <label v-if="item.orderEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.orderEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>
              <div v-if="!item.advanced">
                <span>{{ $t('hrmEnabled') }}: </span>
                <label v-if="item.hrmEnabled" class="badge badge-success">{{ $t('yes') }}</label>
                <label v-if="!item.hrmEnabled" class="badge badge-danger">{{ $t('no') }}</label>
              </div>

            </div>
            <div class="col-lg-1">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col"
                       v-if="['admin', 'owner', 'operationsManager'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1"
                            v-if="!item.default">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" size="lg" @ok="save" no-close-on-backdrop no-enforce-focus>
      <country-select :model="formModel" :errors="formErrors"></country-select>
      <form-checkbox :chk-label="$t('default')" :model="formModel" attribute="default"
                     :errors="formErrors" />
      <form-checkbox :chk-label="$t('advanced')" :model="formModel" attribute="advanced"
                     :errors="formErrors" />
      <form-checkbox :chk-label="$t('unlimitedUser')" :model="formModel" attribute="unlimitedUser"
                     :errors="formErrors" />
      <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
      <template v-if="!formModel.unlimitedUser">
        <div class="row">
          <div class="col-md">
            <form-input :label="$t('userPrice')" :model="formModel" attribute="userPrice" :errors="formErrors"/>
            <form-input v-if="formModel.advanced" :label="$t('channelNumber')" :model="formModel" attribute="channelNumber" :errors="formErrors"/>
            <form-input :label="$t('numberLimit')" :model="formModel" attribute="numberLimit" :errors="formErrors"/>
            <form-input v-if="formModel.advanced" :label="$t('automationWorkflowLimit')" :model="formModel" attribute="automationWorkflowLimit" :errors="formErrors" :placeholder="$t('unlimitedIfEmpty')"/>
          </div>
          <div class="col-md">
            <form-input v-if="formModel.advanced" :label="$t('channelPrice')" :model="formModel" attribute="channelPrice" :errors="formErrors"/>
            <form-input v-if="formModel.advanced" :label="$t('advancedNumber')" :model="formModel" attribute="advancedNumber" :errors="formErrors"/>
            <form-input :label="$t('socialNetworkAccountLimit')" :model="formModel" attribute="socialNetworkAccountLimit" :errors="formErrors"/>
            <form-input v-if="formModel.advanced" :label="$t('automationLimit')" :model="formModel" attribute="automationLimit" :errors="formErrors" :placeholder="$t('unlimitedIfEmpty')"/>
          </div>
        </div>
      </template>
      <template v-else>
        <form-input :label="$t('audioCallPrice')" :model="formModel" attribute="audioCallPrice" :errors="formErrors" />
        <form-input :label="$t('videoCallPrice')" :model="formModel" attribute="videoCallPrice" :errors="formErrors" />
        <form-input :label="$t('customerPrice')" :model="formModel" attribute="customerPrice" :errors="formErrors" />
        <form-input :label="$t('opportunityPrice')" :model="formModel" attribute="opportunityPrice" :errors="formErrors" />
        <form-input :label="$t('ticketPrice')" :model="formModel" attribute="ticketPrice" :errors="formErrors" />
        <form-input :label="$t('campaignContactPrice')" :model="formModel" attribute="campaignContactPrice" :errors="formErrors" />
      </template>

      <div class="row">
        <div class="col-md">
          <form-checkbox :chk-label="$t('callEnabled')" :model="formModel" attribute="callEnabled"
                         :errors="formErrors"></form-checkbox>
          <form-checkbox :chk-label="$t('multiChannelEnabled')" :model="formModel" attribute="multiChannelEnabled"
                         :errors="formErrors"></form-checkbox>
        </div>
        <div class="col-md">
          <form-checkbox v-if="!formModel.advanced" :chk-label="$t('callCampaignEnabled')" :model="formModel" attribute="callCampaignEnabled"
                         :errors="formErrors"></form-checkbox>
          <form-checkbox v-if="!formModel.advanced" :chk-label="$t('pipelineEnabled')" :model="formModel" attribute="pipelineEnabled"
                         :errors="formErrors"></form-checkbox>
          <form-checkbox :chk-label="$t('integrationEnabled')" :model="formModel" attribute="integrationEnabled"
                         :errors="formErrors"></form-checkbox>
          <form-checkbox v-if="!formModel.advanced" :chk-label="$t('ticketEnabled')" :model="formModel" attribute="ticketEnabled"
                         :errors="formErrors"></form-checkbox>
          <form-checkbox v-if="!formModel.advanced" :chk-label="$t('aiEnabled')" :model="formModel" attribute="aiEnabled"
                         :errors="formErrors"></form-checkbox>
          <form-checkbox v-if="!formModel.advanced" :chk-label="$t('orderEnabled')" :model="formModel" attribute="orderEnabled"
                         :errors="formErrors"></form-checkbox>
          <form-checkbox v-if="!formModel.advanced" :chk-label="$t('hrmEnabled')" :model="formModel" attribute="hrmEnabled"
                         :errors="formErrors"></form-checkbox>
          <!-- Trần THẬT còn bị chặn bởi số lượng số gọi ra: tổng đài khoá đồng thời theo
               từng số, nên 1 số thì dù gói cho 20 vẫn chỉ chạy được 1 cuộc.
               Gói theo kênh vẫn cần ô này: khách tự mua AI ở Cài đặt > Gói dịch vụ, trần lấy từ gói -->
          <form-input type="number" :model="formModel" attribute="aiMaxConcurrent"
                      :label="$t('aiMaxConcurrent')" :errors="formErrors"
                      :place-holder="$t('aiMaxConcurrentPlaceholder')"></form-input>

          <form-checkbox :chk-label="$t('kpiEnabled')" :model="formModel" attribute="kpiEnabled"
                         :errors="formErrors"></form-checkbox>

          <form-checkbox :chk-label="$t('phonebookEnabled')" :model="formModel" attribute="phonebookEnabled"
                         :errors="formErrors"></form-checkbox>

          <form-checkbox v-if="formModel.callEnabled" :chk-label="$t('videoEnabled')" :model="formModel" attribute="videoEnabled"
                         :errors="formErrors"></form-checkbox>
        </div>
      </div>
      <template v-if="formModel.advanced && formModel.callEnabled && formModel.videoEnabled">
        <div class="row">
            <form-input class="col-md" :label="$t('videoCCUPrice')" :model="formModel" attribute="videoCCUPrice" :errors="formErrors"/>
            <form-input class="col-md" :label="$t('videoRecordingPrice')" :model="formModel" attribute="videoCCURecordingPrice" :errors="formErrors"/>
            <form-input class="col-md" :label="$t('videoCCUNumber')" :model="formModel" attribute="videoCCUNumber" :errors="formErrors"/>
        </div>
      </template>
      <!--      <form-input :label="$t('storageLimit')" :model="formModel" attribute="storageLimit" :errors="formErrors" />-->
    </b-modal>
  </main>
</template>
<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import CountrySelect from "@/components/CountrySelect";

export default {
  components: {CountrySelect},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/plan',
      defaultFilterFormModel: {
        countryIndex: 0,
      },
      defaultFormModel: {
        default: false,
        advanced: true,
        name: null,
        unlimitedUser: false,
        userPrice: null,
        userBlock: null,
        ticketEnabled: false,
        customFieldEnabled: false,
        eventEnabled: false,
        aiEnabled: false,
        integrationEnabled: false,
        orderEnabled: false,
        hrmEnabled: false,
        storageLimit: 5,
        callEnabled: false,
        videoEnabled: false
      },
      autoLoad: true
    }
  },
  i18n: {
    messages: {
      en: {
        plan: 'Plan',
        detail: 'Detail',
        userPrice: 'Price/user/month',
        userBlock: 'User block',
        pipelineEnabled: 'Pipeline',
        multiChannelEnabled: 'Multi-channel',
        callCampaignEnabled: 'Call campaign',
        kpiEnabled: 'KPI',
        storageLimit: 'Storage limit per user (GB)',
        yes: 'Yes',
        no: 'No',
        default: 'Default',
        ticketEnabled: 'Ticket',
        aiEnabled: "Gọi tự động bằng AI",
        orderEnabled: "Sản phẩm, kho vận, đơn hàng",
        hrmEnabled: "Quản lý nhân sự (chấm công, nghỉ phép, lương)",
        phonebookEnabled: "Danh bạ số điện thoại",
        socialNetworkAccountLimit: "Giới hạn tài khoản mạng xã hội",
        numberLimit: "Giới hạn số điện thoại",
        automationWorkflowLimit: "Giới hạn quy trình tự động hoá",
        automationLimit: "Giới hạn tự động hoá",
        unlimitedIfEmpty: "Để trống = vô hạn",
        channelPrice: "Giá/kênh phát sinh",
        advancedNumber: "Số chức năng nâng cao",
        channelNumber: "Số kênh (Đa kênh, gọi thoại)",
        callEnabled: "Gọi thoại",
        setup: "Cài dặt",
        advanced: "Gói dịch vụ theo kênh",
        integrationEnabled: "Tích hợp",
        videoEnabled: "Gọi video nội bộ",
        videoCCUPrice: "Giá/1 CCU - Không ghi hình",
        videoRecordingPrice: "Giá/1 CCU - Có ghi hình",
        videoCCUNumber: "Số CCU miễn phí"
      },
      vi: {
        plan: 'Gói dịch vụ',
        detail: 'Thông tin gói dịch vụ',
        userPrice: 'Giá/user/tháng',
        userBlock: 'Block người dùng',
        pipelineEnabled: 'Pipeline bán hàng (Nâng cao)',
        multiChannelEnabled: 'Đa kênh (Kênh)',
        callCampaignEnabled: 'Chiến dịch gọi điện (Nâng cao)',
        kpiEnabled: 'KPI',
        storageLimit: 'Dung lượng lưu trữ/ user (GB)',
        yes: 'Có',
        no: 'Không',
        default: 'Mặc định',
        ticketEnabled: 'Ticket (Nâng cao)',
        aiEnabled: "Gọi tự động (Nâng cao)",
        orderEnabled: "Sản phẩm, kho vận, đơn hàng (Nâng cao)",
        hrmEnabled: "Quản lý nhân sự (Nâng cao)",
        integrationEnabled: "Tích hợp",
        phonebookEnabled: "Danh bạ số điện thoại",
        socialNetworkAccountLimit: "Giới hạn tài khoản mạng xã hội",
        numberLimit: "Giới hạn số điện thoại",
        automationWorkflowLimit: "Giới hạn quy trình tự động hoá",
        automationLimit: "Giới hạn tự động hoá",
        unlimitedIfEmpty: "Để trống = vô hạn",
        channelPrice: "Giá/kênh phát sinh",
        advancedNumber: "Số chức năng nâng cao",
        channelNumber: "Số kênh (Đa kênh, gọi thoại)",
        callEnabled: "Gọi thoại (Kênh)",
        setup: "Cài dặt",
        advanced: "Gói dịch vụ theo kênh",
        videoEnabled: "Gọi video nội bộ",
        videoCCUPrice: "Giá/1 CCU - Không ghi hình",
        videoRecordingPrice: "Giá/1 CCU - Có ghi hình",
        videoCCUNumber: "Số CCU miễn phí"
      }
    }
  },
  methods: {
    getCountryId: function (index) {
      let country = this.$store.state.countries[index];
      return country ? country._id : null;
    },
    load: function () {
      this.filterFormModel.country = this.getCountryId(this.filterFormModel.countryIndex);
      let loader = this.$loading.show();
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    },
    create: function () {
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
      this.formModel.country = this.filterFormModel.country;
      this.formTitle = this.$t('create');
      this.formErrors = [];
      this.showForm = true;
    },
  }
}
</script>